module.exports = __webpack_public_path__ + "static/media/sopt13ru.4d3e6a9d.pdf";